import { useTranslation } from 'react-i18next';
import { Report, Sample } from 'app/services/samples/types';
import { formatDateTime, isDateTime } from 'utils/datetime';
import _ from 'underscore';

type PrintSheetProps = {
  sample: Sample,
  reports?: Report[],
}

const PrintSheet = ({ sample, reports }: PrintSheetProps) => {
  const { t } = useTranslation();

  const result = () => {
    if (!sample.HasResult) return t('entities.sample.results.noresult');
    return sample.Result ? t('entities.sample.results.ok') : t('entities.sample.results.nok');
  };

  const rows = (data: any, keys: string[], translationsNamespace: string) => _.map(keys, (key: string) => {
    const value = data && data[key];

    return (
      <tr key={key}>
        <th>{t(`${translationsNamespace}.${key.toLowerCase()}`)}</th>
        <td>{isDateTime(value) ? formatDateTime(value) : value ? value : '-'}</td>
      </tr>
    );
  });

  return (
    <div className="print-sheet">
      <div className="print-sheet-header">
        <span>Kvalilog</span>
        <span>{`${t('components.sample.printed')}: ${formatDateTime(new Date())}`}</span>
      </div>
      <h1>{sample.AmpouleCode}</h1>
      <p>{sample.SiteAddress}</p>
      {sample.Deleted && <p className="print-sheet-deleted">{t('common.deleted')}</p>}

      <h2>{t('components.sample.sampleinfo')}</h2>
      <table>
        <tbody>
          <tr>
            <th>{t('entities.sample.result')}</th>
            <td>{result()}</td>
          </tr>
          {rows(sample, [ 'AmpouleCode', 'Taker', 'SamplerUnitName', 'PumpStart', 'PumpEnd', 'Liters', 'FlowRate', 'ResultTime', 'ResultStatement', 'ResultBy' ], 'entities.sample')}
        </tbody>
      </table>

      <h2>{t('components.sample.projectinfo')}</h2>
      <table>
        <tbody>
          {rows(sample.Project, [ 'Address', 'Start', 'WorkPlace', 'WorkName', 'WorkerName', 'DemolisherName' ], 'entities.project')}
        </tbody>
      </table>

      <h2>{t('components.sample.pumpinfo')}</h2>
      <table>
        <tbody>
          {rows(sample.Pump, [ 'Code', 'BarCode', 'Model' ], 'entities.pump')}
        </tbody>
      </table>

      {reports && !_.isEmpty(reports) && (
        <>
          <h2>{t('components.sample.reportfile')}</h2>
          {_.map(reports, (report: Report) => <p key={report.Id}>{report.FileName.replaceAll('"', '')}</p>)}
        </>
      )}
    </div>
  );
};

export default PrintSheet;
